import { vModelCheckbox as _vModelCheckbox, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0933150f")

_pushScopeId("data-v-0933150f")
const _hoisted_1 = { class: "common-switch" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("label", _hoisted_1, [
    _withDirectives(_createVNode("input", {
      type: "checkbox",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state = $event)),
      onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeState(...args))),
      disabled: _ctx.inhibit
    }, null, 40, ["disabled"]), [
      [_vModelCheckbox, _ctx.state]
    ]),
    _hoisted_2
  ]))
})